import { Trans } from '~/common/context';
import { Button, Flex, Text, Title } from '@wyz/ui';
import { Link } from 'react-router';
import React from 'react';

function QuoteCartEmpty() {
  return (
    <Flex direction='column' alignItems='center'>
      <Background className='my-5' />
      <Title heading='xl' weight='bold' color='tertiary' className='mb-2'>
        <Trans i18nKey='app.purchase.quote_cart_page.empty_cart.title' />
      </Title>
      <Title className='mb-4'>
        <Trans i18nKey='app.purchase.quote_cart_page.empty_cart.description' />
      </Title>
      <Button
        id='back-to-search-empty'
        variant='primary'
        as={Link}
        to='../search'
      >
        <Text heading='normal' weight='semi-bold' color='white'>
          <Trans i18nKey='app.purchase.quote_cart_page.empty_cart.back_to_search' />
        </Text>
      </Button>
    </Flex>
  );
}

export default QuoteCartEmpty;

function Background(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='512'
      height='352'
      viewBox='0 0 512 352'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M335.749 329.802L156.448 317.264C148.662 316.72 142.797 309.92 143.345 302.075L161.074 48.5383C161.623 40.6932 168.378 34.776 176.164 35.3205L355.465 47.8584C363.249 48.4028 369.116 55.2026 368.568 63.0477L350.839 316.584C350.29 324.43 343.534 330.346 335.749 329.802Z'
        fill='#C1CBD7'
      />
      <path
        d='M307.793 308.703L162.552 298.473L179.691 54.7103L349.359 66.6684L334.046 285.653L307.793 308.703Z'
        fill='#ECF0F3'
      />
      <path
        d='M307.793 308.703L162.581 298.071L179.72 54.3074L349.387 66.2656L334.046 285.653L307.793 308.703Z'
        fill='#ECF0F3'
      />
      <path
        d='M249.785 143.842C255.59 144.251 260.125 146.074 263.388 149.31C266.706 152.55 268.176 156.894 267.796 162.342C267.446 167.363 265.49 171.171 261.929 173.765C258.426 176.309 253.932 177.415 248.449 177.082L247.623 183.062L235.416 182.202L236.048 167.27L240.931 167.615C245.108 167.909 248.318 167.625 250.559 166.763C252.854 165.905 254.094 164.141 254.281 161.47C254.411 159.601 253.998 158.095 253.042 156.954C252.085 155.813 250.685 155.178 248.84 155.048C246.887 154.91 245.329 155.364 244.165 156.409C243.006 157.401 242.361 158.832 242.231 160.701L229.128 159.778C229.247 156.512 230.13 153.622 231.777 151.108C233.479 148.597 235.847 146.698 238.881 145.409C241.973 144.07 245.607 143.548 249.785 143.842ZM240.23 203.476C237.788 203.304 235.829 202.468 234.353 200.968C232.934 199.419 232.297 197.602 232.443 195.519C232.592 193.383 233.476 191.647 235.096 190.312C236.77 188.98 238.827 188.401 241.269 188.573C243.656 188.741 245.559 189.6 246.977 191.149C248.45 192.702 249.112 194.547 248.963 196.684C248.818 198.767 247.908 200.474 246.234 201.805C244.618 203.087 242.617 203.644 240.23 203.476Z'
        fill='#C1CBD7'
      />
      <path
        d='M272.65 184.897C275.764 186.08 277.953 187.828 279.218 190.142C280.511 192.466 280.612 195.091 279.522 198.015C278.517 200.711 276.829 202.476 274.458 203.31C272.127 204.127 269.486 203.991 266.536 202.903L265.115 206.046L258.566 203.559L261.33 195.476L263.949 196.471C266.191 197.322 267.995 197.696 269.362 197.594C270.759 197.502 271.724 196.74 272.259 195.306C272.633 194.302 272.65 193.409 272.311 192.625C271.972 191.842 271.307 191.262 270.318 190.886C269.27 190.488 268.343 190.48 267.536 190.861C266.74 191.213 266.155 191.891 265.781 192.895L258.752 190.225C259.346 188.454 260.297 187.015 261.607 185.908C262.946 184.813 264.551 184.162 266.422 183.956C268.333 183.732 270.409 184.046 272.65 184.897ZM257.759 216.019C256.449 215.522 255.511 214.74 254.945 213.674C254.419 212.59 254.364 211.489 254.781 210.371C255.208 209.224 255.974 208.418 257.078 207.953C258.21 207.499 259.431 207.521 260.741 208.019C262.022 208.505 262.925 209.29 263.452 210.374C264.007 211.469 264.071 212.59 263.644 213.737C263.227 214.855 262.452 215.641 261.319 216.095C260.227 216.531 259.04 216.506 257.759 216.019Z'
        fill='#C1CBD7'
      />
      <path
        d='M309.544 283.939L334.045 285.673L307.792 308.703L309.544 283.939Z'
        fill='#D3DCE3'
      />
      <path
        d='M304.96 51.0272L225.736 45.4873L226.464 35.0728C226.834 29.7778 231.413 25.7837 236.69 26.1528L296.803 30.3562C302.081 30.7253 306.059 35.3177 305.689 40.6128L304.96 51.0272Z'
        fill='#93A5B9'
      />
      <path
        d='M319.595 72.1524L208.303 64.3701L209.344 49.4927C209.873 41.9274 216.313 36.2151 223.728 36.7336L308.169 42.6383C315.583 43.1567 321.165 49.7097 320.636 57.275L319.595 72.1524Z'
        fill='#ABBAC9'
      />
    </svg>
  );
}
